import { createStore } from 'redux';
import reducer from './reducer';
import thunk from 'redux-thunk';
// ==============================|| REDUX - MAIN STORE ||============================== //

const store = createStore(reducer);
const persister = 'Free';

export { store, persister };
